/* eslint-disable*/
import { LocalStorage } from '../store/local-storage';

export const USER_SETTINGS = 'user_settings';
export const LOCAL_USER_DATA = 'user_data';
export const REMEMBER_ME_DATA = 'remember_me_data';
// NOTE: The canonical USER_DATA key is defined in `localisation/index.en.ts` as 'user_data_login'.
// It is removed here to avoid the conflicting value 'user_login_data' that caused silent data loss.
export const USER_ROLE = 'user_role';
export const USER_SITE_ID = 'user_site_id';
export const APIGEE_ACCESS_TOKEN = 'apijee_access_token';

export const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
export const SHOW_RELEASE_NOTES = process.env.REACT_APP_ORG_NAME != 'Eaton_electric_safety_org_Prod';

const SECURITY_API = '/api/security/v2';
const ACCESS_CONTROL_API = '/api/v1/accesscontrol';
const USERACCESSPROFILE = '/api/v/useraccessprofiles';
const FILTER_API = '/api/filter/v2';
const NOTIFICATION = '/api/filter/v2/notifications';
const USER = '/api/user/v2';
const SITES = '/api/site/v2';
const adopterId = process.env.REACT_APP_ADOPER_ID || process.env.ADOPER_ID || '';

export const endPoints = {
    getContent: 'photos',
    userData: 'user',
    login: `${SECURITY_API}/login`,
    siteRegistration: `${SITES}/registration`,
    updateSiteRegistration: (id: string | number) => `${SITES}/${id}/registration`,
    siteCustomers: `${SITES}/customers`,
    searchCustomers: (customerName: string, accountNumber: string) => {
        const params = new URLSearchParams();
        if (customerName) params.append('customerName', customerName);
        if (accountNumber) params.append('accountNumber', accountNumber);
        return `${SITES}/customers/search?${params.toString()}`;
    },
    getCustomerSites: (customerId: string | number) => `${SITES}/${customerId}/sites`,
    searchSites: (customerId: string | number) => `${SITES}/${customerId}/sites/search`,
    getCustomerDetail: (customerId: string | number) => `${SITES}/${customerId}`,
    getSiteDetail: (siteId: string | number) => `${SITES}/${siteId}/details`,
    getDistributorOrganizations: `${SITES}/distributor-organizations?isActive=true`,
    deleteCustomer: (customerId: string | number) => `${SITES}/${customerId}/registration`,
    deleteSite: (siteId: string | number) => `${SITES}/${siteId}/registration`,
    getEULADetails: `${USER}/eula`,
    getOpenSourceDetails: `${USER}/license/download`,
    submitEULA: `${USER}/eula/submit`,
    downloadEULA: `${USER}/eula/downlaod`,
    logOut: () => `${SECURITY_API}/logoff`,
    resetPassword: (email: string) => `${SECURITY_API}/reset/${email}/password/true`,
    resetPasswordNow: () => `${SECURITY_API}/reset/password`,
    changePassword: `${SECURITY_API}/user/password`,
    loggedInDetail: `${SECURITY_API}/tokendetails`,
    refreshToken: `${SECURITY_API}/token/refresh`,
    getUser: `${ACCESS_CONTROL_API}/users`,
    accountRecoveryCode: (id: string) =>
        `${ACCESS_CONTROL_API}/users/${id}/account/recovery`,
    getRecoveryCode: (id: string) =>
        `${ACCESS_CONTROL_API}/users/${id}/verification`,
    sendEmailNotification: `${NOTIFICATION}/email/users/`,
    pushSent: `${NOTIFICATION}/push/sent`,
    pushReceived: `${NOTIFICATION}/push/received`,
    registerDeviceToken: `${NOTIFICATION}/pns/register`,
    unregisterDeviceToken: (userEmail: string, mobileAppId: string) =>
        `${FILTER_API}/${userEmail}/${mobileAppId}/pns/unregister`,
    getUserListBySite: (siteId: string) => `${USER}/${siteId}/users`,
    getAllUsers: `${ACCESS_CONTROL_API}/adopters/${adopterId}/users`,
    getLoggedInUserProfile: `${ACCESS_CONTROL_API}/currentuser`,
    updateUserProfile: `${USER}/updateUserDetails`,
    allUserRoles: `${USER}/roles`,
    inviteUser: `${USER}/registration/invite`,
    userRegistrationValidate: `${USER}/registration/validate`,
    userRegistration: `${USER}/registration`,
    getAssignedRole: (userId: string) =>
        `${USERACCESSPROFILE}/adopters/${adopterId}/users/${userId}`,
    getFiltersBySiteId: (siteId: string) => `${FILTER_API}/${siteId}/getfilters?isRequestFromWeb=true`,
    getFiltersByDistributorOrg: (orgId: string, pageNumber: number, pageSize: number) =>
        `${FILTER_API}/${orgId}/getfilters-by-distributorOrg?pageNumber=${pageNumber}&pageSize=${pageSize}`,
    getFilterByFilterId: (filterId: string) => `${FILTER_API}/${filterId}/getfilterbyfilterid`,
    deactivateFilter: (filterId: string) => `${FILTER_API}/${filterId}/DeactivateFilterByFilterId`,
    reactivateFilter: (filterId: string) => `${FILTER_API}/${filterId}/reactivate`,
    getUserDetail: (userId: string) => `${USER}/${userId}/details`,
    registerFilter: `${FILTER_API}/registration`,
    updateFilterDetails: `${FILTER_API}/updatefilterdetails`,
    getSpareParts: (category: number) =>
        `${FILTER_API}/${category}/Getsparepartsbycategory`,
    replaceComponents: `${FILTER_API}/replaceComponent`,
    getDocumentList: (filterId: string) =>
        `${FILTER_API}/getdocumentslists/${filterId}`,
    uploadImage: (
        filterId: string,
        documentCategory: string,
        imagePath: string,
    ) =>
        `${FILTER_API}/uploadDocuments/${filterId}/${documentCategory}/${imagePath}`,
    downloadDocument: (
        filterId: string,
        documentCategory: string,
        fileName: string,
    ) =>
        `${FILTER_API}/downloaddocuments/${filterId}/${documentCategory}/${fileName}`,
    getAlertsMasterData: () => `${FILTER_API}/getalertsMasterData`,
    postAlertHistory: (filterId: string) =>
        `${FILTER_API}/uploadlogs/${filterId}/AlertLogs/0`,
    getAlertHistory: (filterId: string) =>
        `${FILTER_API}/GetFilterLogs/${filterId}/AlertLogs/30`,
    postOperationalLog: (filterId: string, filterType: number) =>
        `${FILTER_API}/uploadlogs/${filterId}/OperationLogs/${filterType}`,
    getFilterPassKey: (serial_number: string) =>
        `${FILTER_API}/${serial_number}/getfilterpasscode`,
    deleteUserProfile: (siteId: string) => `${USER}/${siteId}/unassignsite`,
    getFilterOverview: (filterType: number) =>
        `${FILTER_API}/${filterType}/GetFilterOverview`,
    downloadFilterOverviewImage: (filterModel: string) =>
        `${FILTER_API}/downloadfilterImage/${filterModel}`,
    getFilterDetailById: (filterid: string) =>
        `${FILTER_API}/${filterid}/getfilterbyfilterid`,
    alertsMasterData: `${FILTER_API}/getalertsMasterData`,
    getAlarmLogs: (filterId: string, limit: number) =>
        `${FILTER_API}/GetFilterLogs/${filterId}/AlertLogs/${limit}`,
    getOperationalFilterLogs: (filterId: string) => `${FILTER_API}/GetFilterLogs/${filterId}/OperationLogs/30`,
    getPressureStatistics: (filterId: string) =>
        `${FILTER_API}/${filterId}/pressure-statistics`,
    getPendingInvites: (siteId: string) => `${SECURITY_API}/pending-invites/${siteId}`,
    updateUser: `${USER}/updateUserDetails`,
    getUserRoles: (userId: string) => `${USER}/${userId}/roles`,
    updateUserRole: (userId: string) => `${USER}/${userId}/role`,
    getUsersByRoleId: (roleId: string) => `${USER}/role/${roleId}/users`,
    deleteUserAccount: (userId: string) => `${USER}/${userId}/profile`,
};

export const API_TYPE = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete',
};

export const userLoginData = async (): Promise<any> => {
    return await LocalStorage.getUserData();
};

export const env_privateJwk = process.env.REACT_APP_PRIVATE_KEY || ''; // paired private key
export const env_VERSION = process.env.REACT_APP_VERSION || '';
export const env_BuildID = process.env.REACT_APP_BUILD_ID || '';
export const env_ORG_NAME = process.env.REACT_APP_ORG_NAME || '';
export const DisableFeatureList = process.env.REACT_APP_DISABLED_FEATURE_LIST || '';
export const env_REACT_APP_FORM_IMAGES_PER_FORM = process.env.REACT_APP_FORM_IMAGES_PER_FORM || '';
export const env_REACT_APP_FORM_NO_OF_PAGES = process.env.REACT_APP_FORM_NO_OF_PAGES || '';
export const env_REACT_APP_FORM_QUE_PER_PAGE = process.env.REACT_APP_FORM_QUE_PER_PAGE || '';
export const env_REACT_APP_FORM_SECTION_PER_PAGE = process.env.REACT_APP_FORM_SECTION_PER_PAGE || '';
export const env_REACT_APP_FORM_SECTIONS_PER_FORM = process.env.REACT_APP_FORM_SECTIONS_PER_FORM || '';
export const env_REACT_APP_FORM_NO_OF_DROPDOWN_ITEMS = process.env.REACT_APP_FORM_NO_OF_DROPDOWN_ITEMS || '';
export const env_REACT_APP_FORM_NAME_LENGTH = process.env.REACT_APP_FORM_NAME_LENGTH || '';
export const env_REACT_APP_FORM_DESCRIPTION_LENGTH = process.env.REACT_APP_FORM_DESCRIPTION_LENGTH || '';
export const env_REACT_APP_FORM_PAGENAME_LENGTH = process.env.REACT_APP_FORM_PAGENAME_LENGTH || '';
export const env_REACT_APP_FORM_SECTIONNAME_LENGTH = process.env.REACT_APP_FORM_SECTIONNAME_LENGTH || '';
export const env_REACT_APP_FORM_QUESTION_LENGTH = process.env.REACT_APP_FORM_QUESTION_LENGTH || '';
export const env_REACT_APP_FORM_ANSWEROPTION_LENGTH = process.env.REACT_APP_FORM_ANSWEROPTION_LENGTH || '';
export const REACT_APP_SESSION_TIMEOUT = process.env.REACT_APP_SESSION_TIMEOUT || '15';

export enum DisableFeatures {
    Equipment = 'equipment',
    PublishFormWithdrawal = 'PublishFormWithdrawal',
}
